import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// tslint:disable: max-file-line-count
export var CSS_WIDE_KEYWORD = {
  initial: 'initial',
  inherit: 'inherit',
  unset: 'unset'
};
export var CSS_NORMAL = {
  normal: 'normal'
};
export var CSS_NONE = {
  none: 'none'
};
export var CSS_AUTO = {
  auto: 'auto'
};
export var CSS_COLOR = {
  transparent: 'transparent',
  currentColor: 'currentColor',
  '000000': '000000',
  FFFFFF: 'FFFFFF',
  121212: '121212',
  '2B87DB': '2B87DB',
  E84260: 'E84260',
  F4F4F4: 'F4F4F4',
  '2E9E00': '2E9E00',
  FF5050: 'FF5050',
  FF9D00: 'FF9D00',
  FFF5D4: 'FFF5D4',
  '7A7A7A': '7A7A7A',
  999999: '999999',
  C9C9C9: 'C9C9C9',
  E4E4E4: 'E4E4E4',
  475258: '475258',
  152242: '152242',
  '0468FF': '0468FF',
  '055DE1': '055DE1',
  FF7E06: 'FF7E06',
  F1F1F1: 'F1F1F1',
  CCDBF1: 'CCDBF1',
  DA6C01: 'DA6C01',
  E8E9EC: 'E8E9EC',
  '004EC4': '004EC4'
};
export var CSS_ALIGN_CONTENT = _objectSpread({
  'flex-start': 'flex-start',
  'flex-end': 'flex-start',
  center: 'center',
  'space-around': 'space-around',
  'space-between': 'space-between'
}, CSS_WIDE_KEYWORD);
export var CSS_ALIGN_ITEMS = _objectSpread({
  'flex-start': 'flex-start',
  'flex-end': 'flex-start',
  center: 'center',
  stretch: 'stretch',
  baseline: 'baseline'
}, CSS_WIDE_KEYWORD, {}, CSS_NORMAL);
export var CSS_ALIGN_SELF = _objectSpread({
  'flex-start': 'flex-start',
  'flex-end': 'flex-start',
  center: 'center',
  'self-start': 'self-start',
  'self-end': 'self-start'
}, CSS_WIDE_KEYWORD, {}, CSS_NORMAL, {}, CSS_AUTO);
export var CSS_BACKGROUND_COLOR = CSS_COLOR;
export var CSS_BACKGROUND_CLIP = _objectSpread({
  'padding-box': 'padding-box',
  'border-box': 'border-box',
  'content-box': 'content-box'
}, CSS_WIDE_KEYWORD);
export var CSS_BORDER_COLOR = CSS_COLOR;
export var CSS_CURSOR = _objectSpread({
  crosshair: 'crosshair',
  default: 'default',
  help: 'help',
  move: 'move',
  pointer: 'pointer',
  progress: 'progress',
  text: 'text',
  wait: 'wait',
  'e-resize': 'e-resize',
  'n-resize': 'n-resize',
  'ne-resize': 'ne-resize',
  'nw-resize': 'nw-resize',
  's-resize': 's-resize',
  'se-resize': 'se-resize',
  'sw-resize': 'sw-resize',
  'w-resize': 'w-resize'
}, CSS_WIDE_KEYWORD, {}, CSS_AUTO);
export var CSS_BOX_SIZING = _objectSpread({
  'padding-box': 'padding-box',
  'border-box': 'border-box',
  'content-box': 'content-box'
}, CSS_AUTO, {}, CSS_WIDE_KEYWORD);
export var CSS_DISPLAY = _objectSpread({
  inline: 'inline',
  'inline-block': 'inline-block',
  block: 'block',
  flex: 'flex',
  'inline-flex': 'inline-flex',
  'table-row': 'table-row',
  'table-cell': 'table-cell',
  table: 'table',
  'inline-table': 'inline-table'
}, CSS_WIDE_KEYWORD, {}, CSS_NONE);
export var CSS_FLEX_DIRECTION = _objectSpread({
  row: 'row',
  'row-reverse': 'row-reverse',
  column: 'column',
  'column-reverse': 'column-reverse'
}, CSS_WIDE_KEYWORD);
export var CSS_FLEX_WRAP = _objectSpread({
  nowrap: 'nowrap',
  wrap: 'wrap',
  'wrap-reverse': 'wrap-reverse'
}, CSS_WIDE_KEYWORD);
export var CSS_FONT_SIZE = _objectSpread({
  0: '0',
  10: '10',
  12: '12',
  14: '14',
  16: '16',
  18: '18',
  22: '22',
  28: '28',
  36: '36'
}, CSS_WIDE_KEYWORD);
export var CSS_FONT_WEIGHT = _objectSpread({
  100: '100',
  200: '200',
  300: '300',
  400: '400',
  500: '500',
  600: '600',
  700: '700',
  800: '800',
  900: '900',
  normal: 'normal',
  bold: 'bold',
  bolder: 'bolder',
  lighter: 'lighter'
}, CSS_WIDE_KEYWORD, {}, CSS_NORMAL);
export var CSS_JUSTIFY_CONTENT = _objectSpread({
  'flex-start': 'flex-start',
  'flex-end': 'flex-start',
  center: 'center',
  'space-between': 'space-between',
  'space-around': 'space-around'
}, CSS_WIDE_KEYWORD, {}, CSS_NORMAL);
export var CSS_LINE_HEIGHT = _objectSpread({
  0: '0',
  12: '12',
  14: '14',
  16: '16',
  18: '18',
  20: '20',
  22: '22',
  24: '24',
  28: '28',
  36: '36',
  48: '48'
}, CSS_WIDE_KEYWORD, {}, CSS_NORMAL);
export var CSS_OVERFLOW = _objectSpread({
  visible: 'visible',
  hidden: 'hidden',
  scroll: 'scroll'
}, CSS_WIDE_KEYWORD, {}, CSS_AUTO);
export var CSS_POSITION = _objectSpread({
  relative: 'relative',
  static: 'static',
  fixed: 'fixed',
  absolute: 'absolute'
}, CSS_WIDE_KEYWORD);
export var CSS_TEXT_ALIGN = _objectSpread({
  center: 'center',
  justify: 'justify',
  left: 'left',
  right: 'right'
}, CSS_WIDE_KEYWORD);
export var CSS_TEXT_DECORATION = _objectSpread({
  'line-through': 'line-through',
  overline: 'overline',
  underline: 'underline'
}, CSS_WIDE_KEYWORD, {}, CSS_NONE);
export var CSS_USER_SELECT = _objectSpread({
  text: 'text',
  contain: 'contain',
  all: 'all'
}, CSS_AUTO, {}, CSS_NONE);
export var CSS_VERTICAL_ALIGN = _objectSpread({
  baseline: 'baseline',
  bottom: 'bottom',
  middle: 'middle',
  sub: 'sub',
  super: 'super',
  'text-bottom': 'text-bottom',
  'text-top': 'text-top',
  top: 'top'
}, CSS_WIDE_KEYWORD);
export var CSS_VISIBILITY = _objectSpread({
  visible: 'visible',
  hidden: 'hidden',
  collapse: 'collapse'
}, CSS_WIDE_KEYWORD);
export var CSS_WHITE_SPACE = _objectSpread({
  nowrap: 'nowrap',
  pre: 'pre',
  'pre-line': 'pre-line',
  'pre-wrap': 'pre-wrap'
}, CSS_WIDE_KEYWORD, {}, CSS_NORMAL);
export var CSS_Z_INDEX = _objectSpread({
  '-1': '1',
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  10: '10'
}, CSS_WIDE_KEYWORD);
export var CSS_WORD_WRAP = _objectSpread({
  'break-word': 'break-word'
}, CSS_WIDE_KEYWORD, {}, CSS_NORMAL);
export var KEY_CODES = {
  W: 87,
  S: 83,
  H: 72,
  J: 74,
  K: 75,
  L: 76,
  A: 65,
  D: 68,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
export var DEFAULT_EVENT_TIMEOUT = 300;
export var DEFAULT_MOUSE_TIMEOUT = 200;
export var MEDIA_TYPE = {
  desktop: 'desktop',
  mobile: 'mobile',
  adaptive: 'adaptive'
};